/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";[_nghost-%COMP%]{position:relative}.dragging[_ngcontent-%COMP%]:before{display:flex;position:absolute;justify-content:center;align-content:center;width:100%;height:100%;z-index:1337}.dragging[_ngcontent-%COMP%]:after{position:absolute;display:block;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:1337;padding:20px;content:'Pudota kuva t\u00E4h\u00E4n vaitaaksesi karttakuvan';background-color:rgba(0,0,0,.5);color:#fff}"];
export { styles as styles };
